//
// Module for the Code Table Index view
//
rs.module("system_/configuration/codetable/index",

    [
        "common/visibility",
        "controls/data/grid",
        "controls/components/event-banner"
    ],

    function (visibility, gridModule, eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, ajaxUrls, columnIds) {

            var codeGroupSelect = $.js(jsSelectors.codeValueForm).js(jsSelectors.codeGroupSelect);
            var loadingSpinner = $.js(jsSelectors.codeValueForm).js(jsSelectors.loadingSpinner);

            var codeGroupKey = $.js(jsSelectors.codeValueForm).js(jsSelectors.codeGroupKey);
            var codeGroupAssignKey = $.js(jsSelectors.codeValueForm).js(jsSelectors.codeGroupAssignKey);
            var codeKey = $.js(jsSelectors.codeValueForm).js(jsSelectors.codeKey);
            var codeValue = $.js(jsSelectors.codeValueForm).js(jsSelectors.codeValue);
            var lockedWarning = $.js(jsSelectors.codeValueForm).js(jsSelectors.lockedWarning);
            var addCodeValueLink = $.js(jsSelectors.codeValueForm).js(jsSelectors.addCodeValueLink);
            var cancelCodeValueButton = $.js(jsSelectors.codeValueForm).js(jsSelectors.cancelCodeValueButton);
            var saveButton = $.js(jsSelectors.codeValueForm).js(jsSelectors.saveButton);

            if (lrsGridApi) {

                // Register code group change event handler to reload grid data
                codeGroupSelect.change(function () {

                    loadingSpinner.show();

                    // Update grid
                    gridModule.update(
                        ajaxUrls.getGridData,
                        { codeGroupKey: this.value },
                        lrsGridApi.agGridApi,
                        function done() {
                            loadingSpinner.hide();
                            lrsGridApi.selectFirstRow();
                        }
                    );

                });

                // Register add/cancel click handlers
                addCodeValueLink.on("click", addCodeValueClicked);
                cancelCodeValueButton.on("click", cancelCodeValueClicked);

                // Register grid selection changed handler
                lrsGridApi.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();

                        $.get(
                            ajaxUrls.getCodeValueForUpdate,
                            { codeGroupKey: codeGroupSelect.val(), codeKey: rows[0][columnIds.codeKey] },

                            function (data) {
                                codeValue.clearErrors().val(data.codeValue);
                                codeGroupKey.val(data.codeGroupKey);
                                codeGroupAssignKey.val(data.codeGroupAssignKey);
                                codeKey.val(data.codeKey);

                                if (data.isLocked) {
                                    codeValue.prop('disabled', true);
                                    visibility.show(lockedWarning);
                                    saveButton.setDisabled();
                                }
                                else {
                                    codeValue.prop('disabled', false);
                                    visibility.hide(lockedWarning);
                                    saveButton.setDisabled(false);
                                }
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });

                // clear errors, current value, and grid selection when add is clicked
                function addCodeValueClicked() {
                    eventBanner.removeAllMessages();

                    codeValue.val('').prop('disabled', false).clearErrors();
                    visibility.hide(lockedWarning);
                    saveButton.setDisabled(false);

                    codeGroupAssignKey.val(-1);
                    codeKey.val(-1);

                    lrsGridApi.selectedValues = null;
                }

                // clear errors and select first grid row when cancel is clicked
                function cancelCodeValueClicked() {
                    eventBanner.removeAllMessages();

                    lrsGridApi.selectedValues = null;
                    lrsGridApi.selectFirstRow();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);